import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import * as authService from 'services/auth.service';
import { RootState } from 'store/store';
import { Error } from 'components/app/_helpers/app-errors.helper';
import { setModal } from 'components/app/_mediator/app.slice';
import { saveToken } from './auth.helper';

export const signIn = createAsyncThunk('auth/signIn', async (payload: authService.SignInReq, { rejectWithValue }) => {
  try {
    const { username, password } = payload;
    const response = await authService.signIn({ username, password });
    saveToken(response.data);
    return response.data;
  } catch (error) {
    return rejectWithValue(Error.reduxErrorHandler(error));
  }
});

export const signUp = createAsyncThunk('auth/signUp', async (payload: authService.SignUpBody, { rejectWithValue }) => {
  try {
    const response = await authService.signUp(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(Error.reduxErrorHandler(error));
  }
});

export const resendSignUpOtpCode = createAsyncThunk(
  'auth/resendSignUpOtpCode',
  async (payload: authService.SendOtpReq, { rejectWithValue }) => {
    try {
      const response = await authService.resendSignUpOtpCode(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);

export const activateAcc = createAsyncThunk(
  'auth/activateAcc',
  async (payload: authService.ActivateAccountReq, { rejectWithValue }) => {
    try {
      const response = await authService.activateAcc(payload);
      saveToken(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);

export const sendOtp = createAsyncThunk(
  'auth/sendOtp',
  async (payload: authService.SendOtpReq, { rejectWithValue }) => {
    try {
      const response = await authService.sendOtp(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async (payload: authService.ResetPasswordReq, { dispatch, getState, rejectWithValue }) => {
    try {
      const user = (getState() as RootState).app__data.user;
      payload.email = user ? user.email : new URLSearchParams(window.location.search).get('email') ?? '';
      await authService.resetPassword(payload);
      toast.info('Your password was changed');
      if (user) dispatch(setModal(0));
      else return 'logIn';
    } catch (error) {
      return rejectWithValue(Error.reduxErrorHandler(error));
    }
  }
);
